(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metropole-sale-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-m-sale-bar]');
    if (!el) return;
    var endsAt = parseInt(el.getAttribute('data-ends-at'), 10);
    if (!endsAt) return;

    // Mirrors setHeaderHeighCustomProperties() in layout/theme.liquid. That ran inline
    // at parse time against the bar as the server rendered it; anything here that
    // removes the bar or changes its height has to re-run it, or the sticky header is
    // offset by a height the page no longer has.
    function resyncHeaderHeight() {
      var header = document.querySelector('header-component');
      var group = document.getElementById('header-group');
      if (!group) return;
      var total = 0;
      for (var i = 0; i < group.children.length; i++) {
        var c = group.children[i];
        if (c === header || !(c instanceof HTMLElement)) continue;
        total += c.offsetHeight;
      }
      document.body.style.setProperty('--header-group-height', total + 'px');
    }

    function expire() {
      el.remove();
      resyncHeaderHeight();
    }

    // A page served from CDN cache after the deadline must not keep advertising the
    // offer. The server already refuses to render an expired bar.
    if (endsAt * 1000 <= Date.now()) {
      expire();
      return;
    }

    // Absent when settings.sale_countdown_enabled is off — the server-rendered end
    // date then just stays as it is, which is the whole fallback.
    var until = el.querySelector('[data-m-sale-until][data-cd-live]');
    if (!until) return;

    var prefix = until.getAttribute('data-cd-prefix');
    var dLabel = until.getAttribute('data-cd-days');
    var hLabel = until.getAttribute('data-cd-hours');
    var mLabel = until.getAttribute('data-cd-minutes');
    var timer;

    function tick() {
      var left = endsAt - Math.floor(Date.now() / 1000);
      if (left <= 0) {
        clearInterval(timer);
        expire();
        return;
      }
      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      until.textContent = prefix + ' ' + d + dLabel + ' ' + h + hLabel + ' ' + m + mLabel;
    }

    tick();
    // The countdown string is longer than the date it replaced, so on a narrow screen
    // it can push the bar onto an extra line. Re-measure once, after the swap.
    resyncHeaderHeight();

    // 30s: the display only resolves to minutes, so it is never more than half a
    // minute stale, and it is cheap enough to leave running on every page.
    timer = setInterval(tick, 30000);
  })();

  } catch(e) { console.error(e); }
})();
})();
